import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const SidebarWrap = styled.div`
    position: sticky;
    top: 0;
    height: 100vh;
    width: 210px;
    background: #424242;
`

export const SidebarMenu = styled.ul`
    margin-top: 20px;
    list-style: none;
`

export const SidebarItem = styled.li``

export const SidebarLink = styled(Link)`
    text-decoration: none;
    display: block;
    padding: 7px 0;
    font-size: 16px;
    color: #c3c4c7;
    transition: all .3s ease;
    padding-left: 20px;
    position: relative;
    margin: 5px 0;

    &:before {
        content: '';
        position: absolute;
        border-left: 4px solid #fff;
        left: 0;
        height: 0;
        bottom: 0;
        transition: all .3s ease;
    }

    &:hover,&.active {
        color: #fff;

        &:before{
            height: 100%;
        }
    }
`